import { useMemo } from 'react';
import { useParams } from 'react-router-dom';

import { getAllMarketStoreStates } from '@/store/use-markets-store';

export default function useSymbol() {
  const { symbol: displaySymbol } = useParams() as Readonly<{ symbol: string }>;

  const symbol = useMemo(() => {
    const markets = getAllMarketStoreStates();
    return (
      Object.keys(markets).find(
        (symbol) => markets[symbol].marketSpec.displaySymbol === displaySymbol,
      ) ?? displaySymbol
    );
  }, [displaySymbol]);

  return symbol;
}
